// LightStateMachine configuration values
export const LIGHT_STATE_MACHINE_CLEAR_PERIOD = 20000;
export const LIGHT_STATE_MACHINE_CACHE_IS_OVER_UPDATE_FOR = 10000;
